//@vendor
const React = require('react');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
//@commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

const { NO_RENOVAR } = require('constants/index');

class CancelCreditCardRenewalSuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.goBackHandler = this.goBackHandler.bind(this);
    }

    goBackHandler() {
        this.props.history.push('/myprofile/cards');
    }

    render() {
        const renewalStatus = this.props.renewalStatus;
        const title = renewalStatus.toUpperCase() === NO_RENOVAR ? formatText('cancelCreditCardRenewal-successTitleActivation') : formatText('cancelCreditCardRenewal-successTitle');
        const subTitle = formatText('cancelCreditCardRenewal-successSubTitle');
        const goBackButtonLabel = formatText('cancelCreditCardRenewal-goBackButton').toUpperCase();

        return (
            <CustomMessageBox
                icon="icon-success"
                title={title}
                subtitle={subTitle}
                textLink={goBackButtonLabel}
                goBackHandler={this.goBackHandler}
            />
        );
    }
}

CancelCreditCardRenewalSuccessStep.propTypes = {
    history: PropTypes.object.isRequired,
    renewalStatus: PropTypes.string.isRequired,
}

module.exports = withRouter(CancelCreditCardRenewalSuccessStep);
